
namespace TabAurous.Reports {
    import fld = TabAurous.Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class OwnJewelleryGrid extends _Ext.GridBase<StockBifurcationRow, any> {
        protected getColumnsKey() { return 'Reports.StockBifurcation'; }
        protected getIdProperty() { return StockBifurcationRow.idProperty; }
        protected getInsertPermission() { return StockBifurcationRow.insertPermission; }
        protected getLocalTextPrefix() { return StockBifurcationRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.OwnJewelleryDetailedService.baseUrl; }
        public ProductIds: [];
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.addDateRangeFilter("VoucherDate", "Date");
            this.setTitle("");
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: 'ProductMaster',
                    multiple: true

                },
                field: 'ProductId',
                title: 'Product',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).ProductIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (this.view.params as ReportFiltersRequest).ProductIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            return filters;
        }
      
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            //buttons.push(Common.ExcelExportHelper.createToolButton({
            //    grid: this,
            //    service: TabAurous.Stock.JewelleryService.baseUrl + '/ListExcel',
            //    onViewSubmit: () => this.onViewSubmit(),
            //    separator: true
            //}));
            //buttons.push({
            //    title: 'Export',
            //    cssClass: 'send-button',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        var items = this.view.getItems();
            //        if (items.length == 0) {
            //            q.alert("Warning", "No data to export", true, 2999);
            //            return;
            //        }
            //        // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
            //        //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
            //        Q.postToService({
            //            service: TabAurous.Stock.OwnJewelleryDetailedService.baseUrl + '/ListExcel',
            //            request: {
            //                Items: items,
            //            },

            //            target: '_blank'
            //        });
            //    }
            //});

            
            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {
                    var x = this.view.getItems();
                    Q.postToService({
                        service: TabAurous.Stock.OwnJewelleryDetailedService.baseUrl + '/ExportExcelWithImages',
                        request: {
                            ProductIds: this.ProductIds
                        },
                        target: '_blank'
                    });
                }
            }
            );

            buttons.push(Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                reportTitle:"Own Jewellery Report"
            }));

            return buttons;
        }
        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            var request = this.view.params; 
            this.ProductIds = request.ProductIds;
            (this.view.params as TransactionRequest).ProductIds = request.ProductIds;
            //(this.view.params as ReportFiltersRequest).VoucherTypeId = vouchertypeid;
            //(this.view.params as ReportFiltersRequest).VoucherNo = voucherno; 
            //this.refresh();
            return true;
        }
    }
}